module.exports={close:"Cerrar",error:"Error",info:"Información",success:"Éxito",warning:"Advertencia"};